import React from 'react';
import {
  RailsImage,
  RailsItem,
  RailsThumbnailItem,
} from '@sls-react/typings/services/rails/item';
import Image from '@sls-react/components/Image';
import useMobile from '@sls-react/hooks/useMobile';
import { FT_FASTLY_IO } from '../../constants/featureToggles';

function getImageUrl(item: RailsThumbnailItem | RailsItem, mobile: boolean) {
  let image: string;
  if (FT_FASTLY_IO) {
    if (item.primary_image) {
      image = item.primary_image.large_url;
    } else {
      image = item.images[0]?.large_url;
    }
  } else {
    if (item.primary_image) {
      if (mobile) {
        image = item.primary_image.mobile_thumb_url;
      } else {
        image = item.primary_image.thumb_url;
      }
    } else {
      if (mobile) {
        image = item.images[0]?.mobile_thumb_url;
      } else {
        image = item.images[0]?.thumb_url;
      }
    }
  }

  return image;
}

interface Props {
  item: RailsThumbnailItem | RailsItem;
  position?: number;
}

const ItemThumbnailImage: React.FC<Props> = ({ item, position }) => {
  const mobile = useMobile();
  const image = getImageUrl(item, mobile);

  return (
    <Image
      className="object-cover rounded-t-lg"
      loading={position != null && position < 2 ? 'eager' : 'lazy'}
      useFastly={{
        crop: '1:1',
        height: 300,
        width: 300,
      }}
      useNextJSImage
      alt={item.name}
      src={image}
    />
  );
};

export default ItemThumbnailImage;
